import { action, createStore } from 'easy-peasy';

const dummyData = [
  {
    id: 1,
    x: 0,
    y: 0,
    width: 3,
    height: 5,
    config: {
      type: "stat-card",
      label: "Card #1",
      testPlanIds: [],
      field: "additions",
      aggregation: "sum"
    },
    data: {
      value: 1
    }
  },
  {
    id: 2,
    x: 3,
    y: 0,
    width: 3,
    height: 10,
    config: {
      type: "pie-chart",
      label: "Card #2",
      testPlanIds: ["testPlanId1", "testPlanId2"],
      field: "additions",
      aggregation: "sum"
    },
    data: [
      { name: "testPlanId1", value: 1 },
      { name: "testPlanId2", value: 2 },
    ]
  },
  {
    id: 2,
    x: 0,
    y: 3,
    width: 12,
    height: 11,
    config: {
      type: "line-chart",
      label: "Card #3",
      testPlanIds: ["testPlanId1", "testPlanId2"],
      field: "deletions",
      aggregation: "sum"
    },
    data: [
      { timestamp: 1674001767, testPlanId1: 1, testPlanId2: 3 },
      { timestamp: 1674002767, testPlanId1: 2, testPlanId2: 0 }
    ]
  }
];

const store = createStore({
  dashboard: {
    items: dummyData.map((item, i) => {
      return {
        x: item.x,
        y: item.y,
        w: item.width,
        h: item.height,
        i: Math.random().toString(36).slice(2),
        attrs: {
          config: item.config,
          data: item.data
        },
      };
    }),
    setItems: action((state, payload) => {
      return {
        ...state,
        items: payload.items
      };
    }),
    isEditing: false,
    setIsEditing: action((state, payload) => {
      return {
        ...state,
        isEditing: payload.isEditing
      };
    }),
  },
  variables: {
    // this is the output from executing test button in TaskNodeDialog
    // check testOutput in TaskNodeDialog.js for more details
    testResponses: {},
    // main auto-suggestions
    // tasks: all tasks for the global variable management dialog
    // tasks: all prior connected tasks for the current task
    // vendors: all avaiable integrations selected in the Assets tab of the TaskNodeDialog
    // other: only { xpertlyRequestToken: "xpertlyRequestToken" } should be avaiable when the "Pause worker after this task" is clicked
    options: {
      tasks: [],
      vendors: {},
      other: {}
    },
    // custom: all alias mapping 
    custom: {},
    // global: global variables should be defined in the auto-suggestions-enabled input field. The task needs to be saved for the new global variable to be used in other auto-suggestions-enabled input field
    global: [],
    // udv: used defined variable manipulations from any prior variable manipulation tasks
    udvm: [],
    // schema: if the worker has a global schema selected, the Assets tab of the TaskNodeDialog of all tasks should be disabled
    // check setSchema function in the containers/Application/pages/EditApplication.js for more details
    schema: {},
    setVariables: action((state, payload) => {
      return {
        ...state,
        [payload.key]: payload.value,
      }
    }),
    clearVariables: action((state, payload) => {
      return {
        testResponses: {},
        options: {
          tasks: [],
          vendors: {},
          other: {}
        },
        custom: {},
        global: [],
        schema: {},
      }
    })
  },
  editor: {
    dirty: false,
    setDirty: action((state, payload) => {
      return {
        ...state,
        dirty: payload.dirty,
      };
    }),
    // only true or false handle will be recorded
    lastClickedHandle: null,
    setLastClickedHandle: action((state, payload) => {
      return {
        ...state,
        lastClickedHandle: payload.lastClickedHandle,
      };
    }),
    readOnly: false,
    setReadOnly: action((state, payload) => {
      return {
        ...state,
        readOnly: payload.readOnly,
      };
    }),
    // accessLevel: ['view', 'view_and_save']
    accessLevel: 'view',
    setAccessLevel: action((state, payload) => {
      return {
        ...state,
        accessLevel: payload.accessLevel,
      };
    }),
  },
  platform: {
    user: null,
    userId: null,
    firstName: '',
    lastName: '',
    role: null,
    orgs: [],
    orgId: localStorage.getItem('orgId') || null,
    tenantId: localStorage.getItem('tenantId') || null,
    permissions: [],
    subscription: null,
    error: null,
    notificationKey: null,
    tours: {
      editor: null
    },
    // actions
    signIn: action((state, payload) => {
      state = {
        ...state,
        ...payload
      };
      return state;
    }),
    signOut: action((state, payload) => {
      localStorage.removeItem('orgId');
      localStorage.removeItem('tenantId');
      return {
        user: null,
        userId: null,
        orgs: [],
        orgId: null,
        tenantId: null,
        role: null,
        error: null,
        permissions: [],
        subscription: null,
        notificationKey: null,
        tours: {
          editor: null
        }
      };
    }),
    assignRole: action((state, payload) => {
      return {
        ...state,
        role: payload,
      }
    }),
    assignPermissions: action((state, payload) => {
      return {
        ...state,
        permissions: payload,
      }
    }),
    setSubscription: action((state, payload) => {
      return {
        ...state,
        subscription: payload,
      };
    }),
    changeCurrentOrg: action((state, payload) => {
      localStorage.setItem('orgId', payload);
      return {
        ...state,
        orgId: payload,
      };
    }),
    changeCurrentTenant: action((state, payload) => {
      localStorage.setItem('tenantId', payload);
      return {
        ...state,
        tenantId: payload,
      };
    }),
    insertError: action((state, payload) => {
      return {
        ...state,
        error: payload,
      };
    }),
    clearError: action((state, payload) => {
      return {
        ...state,
        error: null,
      }
    }),
    refreshOrgs: action((state, payload) => {
      return {
        ...state,
        orgs: payload,
      }
    }),
    refreshChildTenants: action((state, payload) => {
      return {
        ...state,
        childTenants: payload,
      };
    }),
    setName: action((state, payload) => {
      return {
        ...state,
        firstName: payload.firstName,
        lastName: payload.lastName,
      };
    }),
    setNotificationKey: action((state, payload) => {
      return {
        ...state,
        notificationKey: payload,
      };
    }),
    setTours: action((state, payload) => {
      return {
        ...state,
        tours: payload
      }
    })
  },
  layout: {
    shrinkSidebar: false,
    handleShrinkSidebar: action((state, payload) => {
      state.shrinkSidebar = payload;
      return state;
    })
  },
  openai: {
    checking: false,
    dialogOpen: false,
    response: null,
    setChecking: action((state, payload) => {
      return {
        ...state,
        checking: payload,
      };
    }),
    setDialogOpen: action((state, payload) => {
      return {
        ...state,
        dialogOpen: payload
      };
    }),
    setResponse: action((state, payload) => {
      return {
        ...state,
        response: payload,
      };
    })
  },
  ai: {
    query: '',
    setQuery: action((state, payload) => {
      return {
        ...state,
        query: payload,
      }
    })
  },
  openAICreateWorkerDialog: {
    open: false,
    setOpen: action((state, payload) => {
      return {
        ...state,
        open: payload,
      }
    })
  },
  conversations: {
    data: JSON.parse(localStorage.getItem('conversations')) || [],
    setData: action((state, payload) => {
      localStorage.setItem('conversations', JSON.stringify(payload));

      return {
        ...state,
        data: payload,
      };
    }),
    pending: false,
    togglePending: action((state, payload) => {
      return {
        ...state,
        pending: !pending
      }
    })
  }
}, {
  disableImmer: true
});

export default store;
